namespace TabAurous.Administration {
    export interface APIKeysRow {
        ClientId?: string;
        AppName?: string;
        Secret?: string;
        Key?: string;
        Role?: number;
        Button?: string;
    }

    export namespace APIKeysRow {
        export const idProperty = 'ClientId';
        export const nameProperty = 'AppName';
        export const localTextPrefix = 'Administration.APIKeys';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            ClientId = "ClientId",
            AppName = "AppName",
            Secret = "Secret",
            Key = "Key",
            Role = "Role",
            Button = "Button"
        }
    }
}
